export default __webpack_public_path__ + "locales/fr/SMTPSettings.json?hash=74599a037f4bf774018b4645e078a1a8";